
import { BookingCart, Summary } from '@beds2b-group/reusable-components'
import './CartComponent.scss'
import { CartReservationInfo, HotelProperties } from '@beds2b-group/reusable-components/dist/types'
import { useState } from 'react'
import { useCart } from '../../../Contexts/CartContexts'
import { Button, Modal, notification, Typography } from 'antd'
import { ClockCircleOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useCurrencyData } from '../../../Contexts/CurrencyContext'
import { Dayjs } from 'dayjs'
import "react-material-symbols/outlined";
import { changeBookingStatus, createPendingBooking } from '../../../api/repositoryEP'
import { create } from 'domain'
import { useNavigate } from 'react-router-dom'
import { use } from 'echarts'
import i18n from '../../../i18n/i18n'

interface CartComponentProps {
    onClickInPayButton: () => void,
    hotelData: HotelProperties,
    from: Dayjs | null | undefined,
    to: Dayjs | null | undefined,
    notifyRemoveRoom: (roomIndex: number, roomCode: string) => void,
    scrollToPayButton: () => void; // Recibimos la función como prop
    postponedAvailable: boolean;
    bookingId?: string;
    postponedBooking: () => Promise<string | null>;

}


const CartComponent = (props: CartComponentProps) => {
    const { t } = useTranslation();

    const cartContext = useCart();

    const onRemoveService = (serviceIndex: number) => {
        cartContext.removeServiceFromCart(serviceIndex);
    }

    const onRemoveRoom = (roomIndex: number, roomCode: string) => {
        props.notifyRemoveRoom(roomIndex, roomCode);
        cartContext.removeRoomFromCart(roomIndex);
    }


    const consoleCartContext = () => {
        console.warn("CartContext", cartContext.data);
    }

    const [isConfirmEnabled, setIsConfirmEnabled] = useState<boolean>(false);
    const { doExchangeCurrency, currencyData } = useCurrencyData();


    const convertCartPrices = (cart: CartReservationInfo): CartReservationInfo => {
        if (!cart || !cart.rooms) return cart;

        const destinationCurrency = currencyData.currencySelectedISO;

        const convertedRooms = cart.rooms.map(room => {
            const originCurrency = room.price.currency;

            // Convertimos los precios principales
            const convertedPvp = doExchangeCurrency(originCurrency, destinationCurrency, room.price.pvp);
            const convertedNet = doExchangeCurrency(originCurrency, destinationCurrency, room.price.net);
            const convertedCommission = doExchangeCurrency(originCurrency, destinationCurrency, room.price.commission);

            return {
                ...room,
                price: {
                    ...room.price,
                    pvp: convertedPvp,
                    net: convertedNet,
                    commission: convertedCommission,
                    currency: destinationCurrency, // actualizamos la moneda
                }
            };
        });

        const convertedServices = cart.services?.map(service => {
            if (!service.price) return service;
            const originCurrency = service.price.currency;

            const convertedPvp = doExchangeCurrency(originCurrency, destinationCurrency, service.price.pvp);
            const convertedNet = doExchangeCurrency(originCurrency, destinationCurrency, service.price.net);
            const convertedCommission = doExchangeCurrency(originCurrency, destinationCurrency, service.price.commission);

            return {
                ...service,
                price: {
                    ...service.price,
                    pvp: convertedPvp,
                    net: convertedNet,
                    commission: convertedCommission,
                    currency: destinationCurrency,
                }
            };
        }) ?? [];

        return {
            ...cart,
            rooms: convertedRooms,
            services: convertedServices
        };
    };
    const [openModalConfirmationPostone, setOpenModalConfirmationPostone] = useState(false);



    const saveForLater = () => {
        setOpenModalConfirmationPostone(true);

    }


    const [loadingPostpone, setLoadingPostpone] = useState(false);
    const navigate = useNavigate();
    const language = i18n.language || "es";


    const handlePostponeBooking = async () => {
        if (loadingPostpone) return;

        try {
            setLoadingPostpone(true);

            const id = await props.postponedBooking();

            if (id) {
                notification.success({
                    message: t("common.postponed"),
                    description: t("modal.postponed-booking.success"),
                    placement: "topRight",
                });

                setOpenModalConfirmationPostone(false);

                setTimeout(() => {
                    navigate(`/${language}/private/dashboard`);
                }, 800);

            } else {
                notification.error({
                    message: t("common.error"),
                    description: t("modal.postponed-booking.error"),
                });
            }
        } catch (e) {
            console.error(e);
            notification.error({
                message: t("common.error"),
                description: t("modal.postponed-booking.error"),
            });
        } finally {
            setLoadingPostpone(false);
        }
    };



    return (
        <div className={`cart-component`}>
            {
                <Modal
                    title={t("modal.postponed-booking.title")}
                    centered
                    className="app-modal"
                    open={openModalConfirmationPostone}
                    onCancel={() => setOpenModalConfirmationPostone(false)}
                    footer={
                        <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
                            <Button onClick={() => setOpenModalConfirmationPostone(false)}>
                                {t("common.no")}
                            </Button>
                            <Button
                                type="primary"
                                className="app-button"
                                onClick={handlePostponeBooking}
                                loading={loadingPostpone}
                                disabled={loadingPostpone}
                            >
                                {t("common.yes")}
                            </Button>
                        </div>
                    }
                >
                    <Typography.Paragraph style={{ marginBottom: 0 }}>
                        {t("modal.postponed-booking.description")}
                    </Typography.Paragraph>
                </Modal>


            }
            {
                cartContext.data ?
                    <BookingCart
                        reservation={convertCartPrices(cartContext.data)}
                        removeRoom={onRemoveRoom}
                        removeService={onRemoveService}
                        buttons={
                            [
                                <Button className="app-button full go-confirm" onClick={props.scrollToPayButton}>
                                    <span className={`sol-icon-ok-circled`} /> {t('components.cart-component.go-confirm')}
                                </Button>
                              /*  <div className="other-actions">
                                    {//     <Button className="app-button send-info" onClick={sendCopyToEmail}><SendOutlined /> {t('components.cart-component.send-cart')}</Button> 
                                    }
                                    <Button
                                        disabled={!props.postponedAvailable}

                                        className="app-button full "
                                        onClick={saveForLater}
                                    ><ClockCircleOutlined /> {t('components.cart-component.save-for-later')}</Button>
                                </div>*/
                            ]
                        }
                    />
                    :
                    <>
                        {t('components.cart-component.not-available')}
                    </>
            }


        </div>
    )
}

export default CartComponent